import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useDispatch, useSelector } from "react-redux";
import { selectusers } from "../redux/usersSlice";
import { selectAdmin, selectDevice } from "../redux/adminSlice";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "white",
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
  p: 4,
  borderRadius: "12px",
  textAlign: "center",
  border: "2px solid #f44336",
};

const WarningModal = ({ users, setOpen, setNodeData, nodeId, usersInfo }) => {
  const selectAdminId = useSelector(selectAdmin);
  const selectedDevice = useSelector(selectDevice);
  const dispatch = useDispatch();
  const findName = (id) => {
    const user = usersInfo?.find((user) => user._id === id);
    return user ? `${user.firstName} ${user.lastName}` : "NA";
  };

  return (
    <Modal open={true}>
      <Box sx={modalStyle}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: "bold", color: "#d32f2f" }}>
          ⚠ Warning: Concurrent Editing
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, mb: 2, color: "#555" }}>
          The following users are also editing this entity:
        </Typography>

        <List sx={{ bgcolor: "#f8d7da", borderRadius: "8px", p: 1 }}>
          {users
            ?.filter((user) => user !== `${selectAdminId?._id}-${selectedDevice}`)
            ?.map((user, index) => {
              const [userId, _deviceId] = user.split("-");
              return (
                <>
                <ListItem key={index} divider>
                <ListItemText
                  primary={`👤 ${findName(userId)}`}
                  sx={{ color: "#b71c1c", fontWeight: "bold" }}
                />
              </ListItem>
              {/* <ListItem key={`${index}-device`} divider>
                <ListItemText
                  primary={`🖥️ Device ID: ${deviceId || "Unknown"}`}
                  sx={{ color: "#b71c1c" }}
                />
              </ListItem> */}
                </>
              
              );
            })}
        </List>

        <Button
          variant="contained"
          sx={{
            mt: 3,
            px: 4,
            backgroundColor: "#d32f2f",
            "&:hover": { backgroundColor: "#b71c1c" },
          }}
          onClick={() => {
            dispatch({
              type: "alertremove",
              payload: { id: nodeId, message: "Another user is also editing this business group" },
            });
            setOpen(false);
            setNodeData({});
          }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default WarningModal;
